module.exports = __webpack_public_path__ + "img/265-5.869240b1.jpg";